import { defineMessages } from 'react-intl';

import { generateDropdownOptions } from '@ratehub/base-ui';

import { CoverageAmountValues } from './CurrentDocument';


const CoverageAmountMessages = defineMessages({
    [CoverageAmountValues.UNDER_25K]: {
        id: 'InsLifeWizard.coverage.under25K',
        defaultMessage: 'Under $25K',
    },
    [CoverageAmountValues.UNDER_100K]: {
        id: 'InsLifeWizard.coverage.under100K',
        defaultMessage: '$25K - $100K',
    },
    [CoverageAmountValues.UNDER_250K]: {
        id: 'InsLifeWizard.coverage.under250K',
        defaultMessage: '$100K - $250K',
    },
    [CoverageAmountValues.UNDER_500K]: {
        id: 'InsLifeWizard.coverage.under500K',
        defaultMessage: '$250K - $500K',
    },
    [CoverageAmountValues.UNDER_1M]: {
        id: 'InsLifeWizard.coverage.under1M',
        defaultMessage: '$500K - $1M',
    },
    [CoverageAmountValues.OVER_1M]: {
        id: 'InsLifeWizard.coverage.over1M',
        defaultMessage: 'Over $1M',
    },
    [CoverageAmountValues.NOT_SURE]: {
        id: 'InsLifeWizard.coverage.notSure',
        defaultMessage: 'I\'m not sure',
    },
});

const CoverageAmountOptions = generateDropdownOptions(
    CoverageAmountValues,
    CoverageAmountMessages,
);

export { CoverageAmountMessages };

export default CoverageAmountOptions;
